import styled from "styled-components";
import { Section } from "../../styles/reusables";

export const AboutSection = styled(Section)`
	> div {
		flex-basis: 50%;
	}

	align-items: flex-start;
	justify-content: flex-start;
`;
